import { Dispatch, SetStateAction } from "react";
import TextField from "@mui/material/TextField";
import CloseIcon from "@mui/icons-material/Close";
import { Modal, CardMedia } from "@mui/material";
import { STORAGE_KEYS } from "../constants/storageKeys";
import { getFromStorage } from "../helpers/storage";
import useTranslation from "../hooks/traslation";
interface AddCategoryModalProps {
  name: string;
  price: string;
  description: string;
  open: boolean;
  selectedId: string;
  onClose: () => void;
  setSelectedId: Dispatch<SetStateAction<string>>;
  setOpen: Dispatch<SetStateAction<boolean>>;

  name_ar: string;
  description_ar: string;
  setName_ar: Dispatch<SetStateAction<string>>;
  setDescription_ar: Dispatch<SetStateAction<string>>;
}

export default function ServiceDetails({
  setOpen,
  open,
  name,
  price,
  description,
  selectedId,
  onClose,
  setSelectedId,
  description_ar,
  name_ar,
  setDescription_ar,
  setName_ar,
}: AddCategoryModalProps) {
  const isViewMode = Boolean(selectedId);
  const getLang = getFromStorage(STORAGE_KEYS.language);
  const translate = useTranslation();

  return (
    <Modal className="modal addCategory_modal" open={open} onClose={onClose}>
      <div className="modal-dialog">
        <div className="modal-body">
          <div className="modal_title">
            <h2>{translate?.main?.serviceDetails}</h2>
            <div
              className="btn-close"
              onClick={() => {
                setSelectedId("");
                setOpen(false);
              }}
            >
              <CloseIcon />
            </div>
          </div>

          <form className="form" action="">
            <div className="control_group">
              <label>{translate?.main?.serviceName}</label>
              <TextField
                placeholder={translate?.user?.serviceName}
                fullWidth
                value={name}
                hiddenLabel
                disabled={isViewMode}
              />
            </div>
            <div className="control_group">
              <label>{translate?.main?.serviceName} (Arabic)</label>
              <TextField
                placeholder={translate?.user?.serviceName}
                fullWidth
                value={name_ar}
                hiddenLabel
                disabled={isViewMode}
              />
            </div>

            <div className="control_group">
              <label>{translate?.main?.startingPrice} (BHD)</label>
              <TextField
                placeholder= {translate?.user?.startingPrice}
                fullWidth
                type="text"
                value={price}
                hiddenLabel
                disabled={isViewMode}
              />
            </div>

            <div className="control_group">
              <label>{translate?.globals?.description}</label>
              <TextField
                placeholder='description'
                fullWidth
                value={getLang === "en" ? description : description_ar}
                hiddenLabel
                disabled={true}
                multiline
                maxRows={5}
                minRows={5}
              />
            </div>
          </form>
        </div>
      </div>
    </Modal>
  );
}
